import { useEffect, useState } from 'react';
import { listDocumentTypes } from '../reference-data/reference-data.api';

/**
 * `GET /document-types` needs `fleet.view` — a driver-only session 403s, so the document
 * filter just has no options for them rather than the page failing. `fleet.view`/`fleet_manager`
 * sessions get the full catalogue, same list the truck/trailer document pickers use.
 */
export function useComplianceDocumentTypeOptions(): { text: string; value: string }[] {
  const [options, setOptions] = useState<{ text: string; value: string }[]>([]);

  useEffect(() => {
    let cancelled = false;
    listDocumentTypes()
      .then((types) => {
        if (!cancelled) setOptions(types.map((type) => ({ text: type.name, value: type.id })));
      })
      .catch(() => {
        if (!cancelled) setOptions([]);
      });
    return () => {
      cancelled = true;
    };
  }, []);

  return options;
}
